import React, { FC } from 'react';
import { Email }  from './style';
import FormInputField from 'components/FormInputField';
import { colors } from 'constants/colors';
import { useState, useEffect} from 'react';
import StyledButton from 'components/Button';
import Checkbox from 'components/Checkbox'
import AccountModal from "components/AccountModal";
import VerificationInputField from 'components/VerificationInputField'
import { useRecoilValue } from 'recoil';
import { userEmailSubscriptionState} from 'states/CheckOutStates/atoms'
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

import { useEmailSubscription } from 'customHooks/useEmailSubscription';

import { useChangeEmail } from 'customHooks/useChangeEmail';

const debug = false;


// task RHCFW-226
// For updating user details in the first form use updateUser mutation.
// for changing email use sendEmailVerification and then  changeEmail mutation.
// for phoneNumber, use sendPhoneNumberVerification and then changePhoneNumber


// From Slack descriptiom from @Emmy 
//***
// createEmailSubscription
// mutation CreateEmailSubscription2 { createEmailSubscription(data: {email: "vadimka@vadimka.com", subscriptionTypeIds: ["5f705113-b914-4cee-b503-72c476ae27ee"]})}
// emailUnsubscription

// Vadim
//
// ok, lets start from simple questions, user chachek this checkbox, and clicks "save", what should I send to API? (edited) 
//Emmy
// createEmailSubscription
//Emmy
//The texts from checkboxes should be frome subscriptionType
//Emmy
//Baolong did something similar if can remember
//Vadim
//mutation CreateEmailSubscription2 { createEmailSubscription(data: {email: "vadimka@vadimka.com", subscriptionTypeIds: ["5f705113-b914-4cee-b503-72c476ae27ee"]})}
//this is correct?
//Emmy
//Yes
//Vadim
//ok, now user uncheck checkbox and hit save, what should I send?
//Emmy
//emailUnsubscription
//Vadim
//Where I can get this ID?
//Emmy
//This is got after subscrption
//Vadim
//and, how I can get this ID if user need to be unsubscribed for example tomorrow?
//Vadim
//also, once user come to this page, how can I set this checkbox, how can I check if user subscribed or not?
//Emmy
//emailSubscriptionsByEmail, will get you all subscriptions that's what you show as checked
//Emmy
//others from subscriptionTypes should be unchecked

//---------******----------
//@Vadim the subscription endpoints and input data changed, I also added endpoints for phone subscriptions.
//Here is a list of endpoints, by their names you can know what they do,
//subscriptionTypes, emailSubscriptionsByUser, phoneSubscriptionsByUser, createSubscriptionType, 
//createEmailSubscription, createPhoneSubscription, updateEmailSubscription, updatePhoneSubscription, 
//emailUnsubscription, phoneUnsubscription, emailUnsubscriptionReason, phoneUnsubscriptionReason

//Emmy: Actually, there is a emailReSubscription endpoint
// phoneReSubscription

//---------******----------





const EmailContent: FC = () => {

  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();

  const {
    emailValue,
    newEmailValue,
    changeEmailMoad,
    changeConfirmationMoadal,
    newEmailError,
    newEmailErrorText,
    newVerificationCodeError,
    newVerificationCodeErrorText,
    codeResent,
    CODE_LENGTH,
    verificationCode,
    handleNewEmailChange,
    handleOpenChangeEmail,
    handleCloseChangeEmail,
    handleCloseConfirmation,
    handleVerificationCodeChange,
    handleSendNewEmail,
    handleReSendNewEmail,
    handleChangeEmail
  } = useChangeEmail();

  const [receiveMarketingEmails, setReceiveMarketingEmails] = useState(false);

  /**
 * Masks part of the email by replacing characters with asterisks.
 * @param email - The email address to be masked.
 * @returns The masked email address.
 */

function maskEmail(email: string): string {
  const [localPart, domain] = email.split("@");

  // If the local part is too short, do not mask it
  if (localPart.length <= 2) {
    return email; // Return the original email
  }

  // Mask the local part: keep the first and last characters visible
  const maskedLocalPart =
    localPart[0] + "*".repeat(localPart.length - 2) + localPart[localPart.length - 1];

  return `${maskedLocalPart}@${domain}`;
}

  // Verification code resizing based on window size:

  const [verificationInputInputHeight, setVerificationInputInputHeight] = useState("67px");
  const [verificationInputInputWidth, setVerificationInputInputWidth] = useState("63px");
  const [verificationInputMargin, setVerificationInputMargin] = useState("20px 0");

  useEffect(() => {
    // Function to update the size based on window width
    const handleResize = () => {
      if (window.innerWidth < 500) {
        setVerificationInputInputHeight("40px");
        setVerificationInputInputWidth("40px");
        setVerificationInputMargin ("8px 0 22px 0");
      } else {
        setVerificationInputInputHeight("67px");
        setVerificationInputInputWidth("63px");
        setVerificationInputMargin ("20px 0");
      }
    };

    // Call the function initially to set the size when the component mounts
    handleResize();

    // Add event listener to listen for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


    //**** Email notifications preferences checkbox */
  
    const emailSubscriptionState = useRecoilValue(userEmailSubscriptionState);

    const {
      handleFetchEmailSubscriptionsByUser,
      handleUpdateSubscription,
      isSubscriptionLoading,
      errorState,
      suscessState,
    } = useEmailSubscription();
  
    useEffect (() => {
      if (!isSubscriptionLoading) {
        setReceiveMarketingEmails (emailSubscriptionState.isUserSubscribed);
      }
    }, [emailSubscriptionState.isUserSubscribed, isSubscriptionLoading])

    useEffect(() => {
      if (debug){
        console.log ("current emailSubscriptionState", emailSubscriptionState);
      }
    }, [emailSubscriptionState])
  
    useEffect(() => {
      if (emailSubscriptionState.loadDataFromServer) {
        handleFetchEmailSubscriptionsByUser();
      }
    }, [emailSubscriptionState.loadDataFromServer, handleFetchEmailSubscriptionsByUser]);
  
    useEffect(() => {
      if (errorState.hasError){
        showGlobalError (errorState.message);
  
      }
    }, [errorState, showGlobalError]);
  
    useEffect(() => {
      if (suscessState.isSuscess){
        showGlobalMessage (suscessState.message);
  
      }
    }, [suscessState, showGlobalMessage]);
  
  
    const updateEmailSubscriptionData = () => {
  
      if (debug) {
        console.log ('receiveEmailNotifications = '+ receiveMarketingEmails);
        console.log ('isUserSubscribed = '+ emailSubscriptionState.isUserSubscribed);
      }
  
      if (!isSubscriptionLoading) {
        handleUpdateSubscription(receiveMarketingEmails);
      }
    }
  
  //**** Email notifications preferences checkbox */


  return (
    <Email>



      {/* Change E-mail modal */}
      <AccountModal
        open={changeEmailMoad}
        mobile={false}
        opacity="80%"
        verticalCenterd
        top="0"
        title="Enter New Email Address"
        onClose={handleCloseChangeEmail}
      >
        <div className="accounModalBody emailModal">
          <div className="inpuntCont email">
            <FormInputField
              disabled={false}
              className="secInput"
              // highLightLabel='CURRENT '
              label="EMAIL ADDRESS"
              isRequired
              type="text"
              borderColor={colors.signInBorderColor}
              error={newEmailError}
              errorMessage={newEmailErrorText}
              value={newEmailValue}
              inputHeight="48px"
              marginBottom="20px"
               onChange={handleNewEmailChange}
            />
          </div>
          <div className="continueButton">
            <StyledButton
              width="99px"
              height="48px"
              //backgroundColor = {colors.signInBorderColor}
              //fontColor = {colors.white}
              disabledBackgroundColor={colors.signInBorderColor}
              disabledColor={colors.white}
              onClick={() => {
                handleSendNewEmail ();
              }}
              // disabled={oldPassword.length < 8 || newPassword.length < 8}
              // onClick={handleResetPassword}
            >
              Continue
            </StyledButton>
          </div>
        </div>
      </AccountModal>

      {/* Verify email address modal */}
      <AccountModal
        open={changeConfirmationMoadal}
        mobile={false}
        opacity="80%"
        verticalCenterd
        top="0"
        title="Confirmation Required"
        onClose={handleCloseConfirmation}
      >
        <div className="accounModalBody confirmationMoadal">
          <h4 className="confirmationModalHeader">Verify email address</h4>
          <div className="confirmationModalText">
            A verification code has been sent to your email address {maskEmail(newEmailValue)}. Please enter the code below to confirm your update:
          </div>
          <div className="inpuntCont confirmationModalInput">
            {/* <label>
              <span>VERIFICATION CODE</span>
              <span className="required"> *</span>
            </label> */}
            <VerificationInputField
              label="Verification Code"
              isRequired
              margin={verificationInputMargin}
              width="100%"
              length={CODE_LENGTH}
              values={verificationCode}
              setValues={handleVerificationCodeChange}
              inputHeight = {verificationInputInputHeight}
              inputWidth = {verificationInputInputWidth}
              error={newVerificationCodeError}
              errorMessage={newVerificationCodeErrorText}
              labelSize = "14px"
            />
          </div>
          <div className="continueButton">
            <StyledButton
              width="192px"
              height="48px"
              //backgroundColor = {colors.signInBorderColor}
              //fontColor = {colors.white}
              disabledBackgroundColor={colors.signInBorderColor}
              disabledColor={colors.white}
              // disabled={oldPassword.length < 8 || newPassword.length < 8}
              onClick={() => {
                handleChangeEmail();
              }}
            >
              Verify Email Address
            </StyledButton>
          </div>
          <div className="bottomText">
            {!codeResent ? (
              <>
                Haven’t received the code?&nbsp;
                <button
                  type="button"
                  className="resendCodeLink"
                  onClick={() => {
                    handleReSendNewEmail();
                  }}
                >
                  Resend code
                </button>
              </>
            ) : (
              <>Code Resent.</>
            )}
          </div>
        </div>
      </AccountModal>

      <div className="accountBody">
        <div className="cardContent">
          <div className="topText">
           Your email address has already been verified. If you wish to change
            your email address click the change button below.
          </div>
          <div className="inpuntCont email">
            <FormInputField
              disabled={true}
              className="secInput"
              // highLightLabel='CURRENT '
              label="EMAIL ADDRESS"
              isRequired
              type="text"
              borderColor={colors.signInBorderColor}
              // error={oldPasswordError}
              // errorMessage={errorMessageOldPass}
              value={emailValue}
              inputHeight="48px"
              marginBottom="20px"
              // onChange={(e) => {
              //   setOldPassword(e.target.value)
              //   setNewPasswordSucsess (false)
              //   if(oldPasswordError) {
              //     setOldPasswordError(false)
              //     setNewPasswordSucsess (false)
              //     setSowResetPasswordHint(false)
              //   }
              // }}
            />
          </div>
          <div className="changeButton">
            <StyledButton
              width="99px"
              height="48px"
              //backgroundColor = {colors.signInBorderColor}
              //fontColor = {colors.white}
              disabledBackgroundColor={colors.signInBorderColor}
              disabledColor={colors.white}
              // disabled={oldPassword.length < 8 || newPassword.length < 8}
              onClick={handleOpenChangeEmail}
            >
              Change
            </StyledButton>
          </div>
        </div>
      </div>

      <div className="accountBody">
        <div className="cardContent">
          <h3>Email notification preferences</h3>
          <Checkbox
            className="accountCheckbox"
            checked={receiveMarketingEmails}
            disabled={isSubscriptionLoading}
            //error={termsOfServiceError}
            borderColor={colors.noBookingText}
            label="Receive occasional marketing emails from Rook Hotel."
            onChange={() => {
              if (!isSubscriptionLoading) {
                setReceiveMarketingEmails(!receiveMarketingEmails);
              }
            }}
            checkboxScale={1.2}
          />
          <div className="note">
            <strong>Note:</strong> this does not include account related emails,
            such as booking confirmations, or check-out receipts.
          </div>
          <div className="saveButton">
            <StyledButton
              width="81px"
              height="48px"
              disabledBackgroundColor={colors.signInBorderColor}
              disabledColor={colors.white}
              disabled={isSubscriptionLoading}
              onClick={()=> {
                updateEmailSubscriptionData ();
              }}
            >
              Save
            </StyledButton>
          </div>
        </div>
      </div>
    </Email>
  );
};

export default EmailContent;
